export default "__VITE_ASSET__BZ5lQ1hA__"